module.exports = __webpack_public_path__ + "fonts/ce2322b.woff2";